export default "__VITE_ASSET__C6uvG6to__"